import { createApp } from '../app'

import VueConfetti from 'vue-confetti'
import VueSilentbox from 'vue-silentbox'
import 'vue-silentbox/dist/style.css'
import VueSplide from '@splidejs/vue-splide'
import '@splidejs/vue-splide/css'

export { render }

let app
async function render(pageContext) {
  // Hydration after SSR
  if (pageContext.isHydration) {
    const instance = createApp(pageContext)
    app = instance.app
    instance.store.state.value = pageContext.initialStoreState

    // Only works on client-side, so we need to add it here
    app.use(VueConfetti)
    app.use(VueSilentbox)
    app.use(VueSplide)

    app.mount('#jrCB')
  } else {
    app.changePage(pageContext)
  }
}

//To enable Client-side Routing:
// export const clientRouting = true
